import React from 'react';
import {Card,CardHeader,CardContent} from '@material-ui/core';
import { lang } from '../../../config/app.config';
// import translates from '../../../translation.json';
import { TranslationState } from '../../../store/ActionReducers/translation.actionreducer';
import {useSelector} from 'react-redux';


const FBfeeds:React.FC =  ()=>{
  const state = useSelector((state:{translation:TranslationState})=>state.translation);
  return(
    <Card>
      <CardHeader title={state.translation?state.translation.facebook_feeds[lang === 'np'?'value_np':'value_en']:''} className="card-header-primary"/>
      <CardContent className="bg-primary custom-card-body">
      <iframe style={{width:'100% '}} src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fecnofficial&tabs=timeline&width=340&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=239464641053195" width="340" height="400" scrolling="no" frameBorder="0" allowFullScreen={true} 
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" title="Facebook feeds"></iframe>
      </CardContent>
    </Card>
  );
}

export default FBfeeds;